import { Routes, Route, Navigate } from 'react-router-dom';
import { EventsPage, EventPage, ProposalsPage, BoardPage, KioskBoardPage, AdminPage, PresentPage } from './pages';
import { ActiveEventRedirect } from './components/ActiveEventRedirect';
import { ActiveEventKioskRedirect } from './components/ActiveEventKioskRedirect';
import { GlobalPresentingOverlay } from './components/GlobalPresentingOverlay';

function App() {
  return (
    <>
      <Routes>
        {/* Pretty URL: /sessionboard → active event */}
        <Route path="/" element={<ActiveEventRedirect />} />

        {/* Kiosk display (no login, fullscreen) */}
        <Route path="/kiosk" element={<ActiveEventKioskRedirect />} />

        {/* Admin: event management (hidden from regular users) */}
        <Route path="/admin/events" element={<EventsPage />} />

        {/* Event routes (UUID-based, still functional) */}
        <Route path="/event/:eventId" element={<EventPage />} />
        <Route path="/event/:eventId/proposals" element={<ProposalsPage />} />
        <Route path="/event/:eventId/board" element={<BoardPage />} />
        <Route path="/event/:eventId/kiosk" element={<KioskBoardPage />} />
        <Route path="/event/:eventId/present" element={<PresentPage />} />
        <Route path="/event/:eventId/admin" element={<AdminPage />} />

        {/* Legacy redirects */}
        <Route path="/events" element={<Navigate to="/admin/events" replace />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Global presenting overlay – shows on any page when a card is being presented */}
      <GlobalPresentingOverlay />
    </>
  );
}

export default App;
